import styled from "@emotion/styled";
import { Toys } from "@mui/icons-material";
import { Container, Link, Typography } from "@mui/material";
import { Grid } from "@mui/material";
import TelegramIcon from "@mui/icons-material/Telegram";

const MainContainer = styled(Container)`
  margin-top: 30px;
  @media (min-width: 600px) {
    padding-top: 50px;
    padding-bottom: 50px;
    margin-top: 50px;
  }
`;
const WrapperGrid = styled(Grid)`
  background-image: url("./assets/footerbg.png");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  border-radius: 24px;
  padding-top: 80px;
  padding-bottom: 80px;
  @media (max-width: 600px) {
    padding-top: 0px;
    padding-bottom: 0px;
    background-size: cover;
  }
  @media (max-width: 1000px) and (min-width: 601px) {
    padding-top: 55px;
    padding-bottom: 55px;
  }
  @media (min-width: 1300px) {
    padding-top: 100px;
    padding-bottom: 100px;
  }
`;
const Heading = styled(Typography)`
  font-family: GaeguBold;
  font-size: 60px;
  color: #ffb988;
  text-transform: uppercase;
  @media (max-width: 600px) {
    font-size: 24px;
  }
  @media (max-width: 1000px) and (min-width: 601px) {
    font-size: 30px;
  }
`;
const SubHeading = styled(Typography)`
  font-family: GaeguRegular;
  font-size: 18px;
  color: #2a3382;
  text-transform: uppercase;
  padding-left: 20px;
`;
const SocialHeading = styled(Typography)`
  font-family: GaeguBold;
  font-size: 20px;
  color: #ffb988;
  text-transform: uppercase;
  margin-right: 5px;
`;
const SocialImg = styled.img`
  margin: 0px 10px 0px 10px;
  width: 40px;
  @media (max-width: 600px) {
    width: 20px;
    height: 20px;
  }
`;
const CopyRight = styled(Typography)`
  font-size: 18px;
  font-family: Segoe UI;
  color: #2a3382;
  text-align: center;
`;
const SocialWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 50px;
  align-items: center;
  @media (max-width: 600px) {
    align-items: center;
  }
  @media (max-width: 1000px) {
    margin-top: 20px;
  }
`;
const CopyRightContainer = styled(Grid)`
  margin-top: 50px;
  @media (max-width: 600px) {
    margin-top: 20px;
  }
`;
const HeadingGrid = styled(Grid)`
  padding-top: 5px !important;
`;
export default function Footer() {
  return (
    <MainContainer>
      <WrapperGrid container spacing={2}>
        <Grid item xs={12}>
          <SubHeading>Shih Tzu Community</SubHeading>
        </Grid>
        <HeadingGrid item xs={12}>
          <Heading>Join our community</Heading>
        </HeadingGrid>
        <Grid item xs={12}>
          <SocialWrapper>
            <SocialHeading>JOIN US:</SocialHeading>
            <Link href="https://t.me/shihtzuonbase" target="blank"> 
            <TelegramIcon
              sx={{
                padding: "5px",
                backgroundColor: "#0089ff",
                borderRadius: "20px",
                fontSize: "40px",
                color: "#fff",
              }}
            /></Link>
            <Link href="https://twitter.com/shihtzuonbase"  target="blank">
              <SocialImg src="./assets/twitter.png" alt="" />
            </Link>
          </SocialWrapper>
        </Grid>
      </WrapperGrid>
      <CopyRightContainer container>
        <Grid item xs={12}>
          <CopyRight>Copyright © 2023 shih tzu</CopyRight>
        </Grid>
      </CopyRightContainer>
    </MainContainer>
  );
}
